import { createAction } from '@store/utils';

export const cacheByName = createAction('cache/CACHE_BY_NAME');

export const actions = {
    cacheByName,
};
